import { SEO } from 'components/Seo/Seo';
import useAppLanguage from 'hooks/useAppLanguage';
import { useState } from 'react';

import { createFileRoute } from '@tanstack/react-router';
import PrivateCreditProductData from './components/PrivateCreditProductData';
import ProductBundleData from './components/ProductBundleData';
import ProductDefaultData from './components/ProductDefaultData';
import BackButton from 'components/BackButton/BackButton';
import { CustomLoader } from 'components/CustomLoader/CustomLoader';
import { TimeFrameKey } from 'data/time-frames';
import { useProduct } from 'hooks/products/useProducts';
import { useGetBundleInfo } from 'store/slices/cdn-api';
import { useGetProductDetailsQuery } from 'store/slices/products-api';

import { ActiveProductDtoTypeEnum } from 'services/generated/api';
import ProductStocksData from './components/ProductStocksData';

export const Route = createFileRoute('/_authenticated/products/$productCode')({
  component: ProductDetailsPage,
});

function ProductDetailsPage() {
  const { productCode } = Route.useParams();
  const { product } = useProduct(productCode);
  const { data: productDetails } = useGetProductDetailsQuery(productCode);
  const { data: bundleInfo } = useGetBundleInfo(productCode);
  const [currentTimeFrame, setCurrentTimeFrame] = useState<TimeFrameKey>('24h');


  return (
    <>
      <SEO
        title={`Product ${productCode?.toUpperCase()}`}
        description="Product details, holdings, and savings."
        keywords="Product, Bitcoin, BTC, Ethereum, ETH, Savings, Vault, DeFi"
        page="productDetails"
      />

      <div className="py-0 lg:mt-0">
        <div className="w-full">
          {!product || !productDetails ? (
            <div className="w-full px-2">
              <CustomLoader page />
            </div>
          ) : (
            <>
              <div className="w-full">
                <BackButton
                  className={
                    'w-full text-left lg:bg-body-background mt-1 lg:-mt-2 pt-2 lg:ml-0 lg:pl-6'
                  }
                />
              </div>
              <div className="w-full pt-2 lg:pt-20">
                {product?.type === ActiveProductDtoTypeEnum.PrivateCredit && (
                  <PrivateCreditProductData code={productCode} />
                )}
                {product?.type === ActiveProductDtoTypeEnum.Bundle && ( 
                  <>
                   <ProductBundleData
                      code={productCode}
                      timeFrame={currentTimeFrame}
                      setTimeframeKey={setCurrentTimeFrame}
                      methodology={productDetails.methodology}
                      factsheet={productDetails.factsheet}
                      activeBundle={bundleInfo}
                    />
                  </>
                )}
                {product?.type === ActiveProductDtoTypeEnum.Stock && ( 
                  <>
                    <ProductStocksData
                      code={productCode}
                      timeFrame={currentTimeFrame}
                      setTimeframeKey={setCurrentTimeFrame}
                    />
                  </>
                )}
                {(
                  product?.type !== ActiveProductDtoTypeEnum.Stock &&
                  product?.type !== ActiveProductDtoTypeEnum.PrivateCredit &&
                  product?.type !== ActiveProductDtoTypeEnum.Bundle
                ) && ( 
                  <>
                    <ProductDefaultData
                      code={productCode}
                      timeFrame={currentTimeFrame}
                      setTimeframeKey={setCurrentTimeFrame}
                    />
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default ProductDetailsPage;
